import React, { useEffect, useRef, useState } from "react";
import spinSoundSrc from "../assets/audio/spinSound.mp3";
import coinSoundSrc from "../assets/audio/coinsSound.mp3";
import MuteIcon from "../assets/image/mute.png";
import UnmuteIcon from "../assets/image/unmute.png";
import SelectCricle from "./SelectCricle";
import DimondIcon from "../assets/image/diamond 2.png";
import HandIcon from "../assets/image/head.png";
import RecordsDialog from "../Dialog/RecordsDialog";
import RulesDialog from "../Dialog/RulesDialog";
import CoinButton, { chipImageForAmount } from "./CoinButton";
import { ToastConent } from "../ToastConent";
import WinnerDialog from "../Dialog/WinnerDialog";
import Leaderboard from "../Dialog/Leaderboard";
import { imageShowData } from "../GiftImage";
import WheelCircle from "../assets/image/wheel circle.png";
import WheelMiddle from "../assets/image/wheel middle.png";
import WheelBottomStand from "../assets/image/wheel-bottom-stand.png";
import WheelStandTop from "../assets/image/wheel-stand-top.png";
import WheelPointer from "../assets/image/wheel-pointer.png";
import BalanceBanner from "../assets/image/Balance Banner.png";
import ResultBanner from "../assets/image/result banner.png";
import AppleBox from "../assets/image/AppleBox.png";
import MangoBox from "../assets/image/MangoBox.png";
import WatermelonBox from "../assets/image/WatermelonBox.png";
// The wheel is ordered clockwise from the top: Apple, Mango, Watermelon,
// Apple, Mango, Watermelon.  Each fruit pot therefore owns two wedges.
const POT_SEGMENTS = {
  1: [0, 3], // Apple
  2: [1, 4], // Mango
  3: [2, 5], // Watermelon
};
const WEDGE_DEGREES = 60;
const SPIN_DURATION_MS = 7000;
const FREE_SPIN_DEGREES_PER_MS = 0.9;

// Clip-path polygons for 6 equal wheel segments (60° each).
// wheel circle.png is a PURE circle — center is exactly (50%, 50%), radius 48%.
// 6 segments × 60° each, starting from top (-90°).
// Each polygon: center → 5 arc points to smoothly approximate the arc edge.
const CX = 50, CY = 50, R = 48; // percentages — exact for the pure circle image
function arcPoint(angleDeg) {
  const rad = (angleDeg * Math.PI) / 180;
  return `${(CX + R * Math.cos(rad)).toFixed(2)}% ${(CY + R * Math.sin(rad)).toFixed(2)}%`;
}
const segmentClipPaths = Array.from({ length: 6 }, (_, i) => {
  const startDeg = -90 + i * 60;
  const endDeg = startDeg + 60;
  const points = [
    `${CX}% ${CY}%`,     // center
    arcPoint(startDeg),
    arcPoint(startDeg + 12),
    arcPoint(startDeg + 24),
    arcPoint(startDeg + 36),
    arcPoint(startDeg + 48),
    arcPoint(endDeg),
  ];
  return `polygon(${points.join(", ")})`;
});

const BADGE_R = 32; // Distance from center for the bet badge (0-50%)
const betBadgePositions = Array.from({ length: 6 }, (_, i) => {
  const midDeg = -90 + i * 60 + 30; // middle of the 60 degree wedge
  const rad = (midDeg * Math.PI) / 180;
  return {
    left: `${(CX + BADGE_R * Math.cos(rad)).toFixed(2)}%`,
    top: `${(CY + BADGE_R * Math.sin(rad)).toFixed(2)}%`,
  };
});

const handClasses = ["hand1", "hand2", "hand3", "hand4", "hand5", "hand6"];
let selectedCoin = 0;
let selectedFram = [
  { selectFrame: 1, Bit: 0 },
  { selectFrame: 2, Bit: 0 },
  { selectFrame: 3, Bit: 0 },
  { selectFrame: 4, Bit: 0 },
  { selectFrame: 5, Bit: 0 },
  { selectFrame: 6, Bit: 0 },
];
let totalMineBetCoin = 0;
let winnerFram = 0;
let todayProfit = 0;
let historiesShow = [];
let gameRound = 0;
let gameRoundWinnerShow = 0;
let winnerShow = [];
let historyRecord = [];
let currentGame = [];
const queryParams = new URLSearchParams(window.location.search);
const userId = queryParams.get("id");

export default function WheelContent(props) {
  const { userData, socket, gameCoin } = props;
  const [seconds, setSeconds] = useState(0);
  const [roundCounter, setRoundCounter] = useState(0);
  const [rollCount, setRollCount] = useState(0);
  const [handClassIndex, setHandClassIndex] = useState(0);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [recordsDialogOpen, setRecordsDialogOpen] = useState(false);
  const [rulesDialogOpen, setRulesDialogOpen] = useState(false);
  const [leaderboardDialogOpen, setLeaderboardDialogOpen] = useState(false);
  const [winnerModelOpen, setWinnerModelOpen] = useState(false);
  const [time, setTime] = useState();
  const [canPressCoins, setCanPressCoins] = useState(true);
  const [timerText, setTimerText] = useState("20");
  const [showCricle, setShowCricle] = useState(false);
  const [showHandImage, setShowHandImage] = useState(false);
  const [isMuted, setIsMuted] = useState(false); // mute/unmute toggle
  const [wheelRotation, setWheelRotation] = useState(0); // Wheel Rotation
  const [isSpinning, setIsSpinning] = useState(false); // Wheel Rotation
  const [spinPhase, setSpinPhase] = useState("idle");
  const [resultHistory, setResultHistory] = useState([]);
  const [potBets, setPotBets] = useState({
    totals: { 1: 0, 2: 0, 3: 0 },
    mine: { 1: 0, 2: 0, 3: 0 },
  });
  const [betChips, setBetChips] = useState({ 1: [], 2: [], 3: [] });
  const chipSequenceRef = useRef(0);


  // ── Spin Sound (Web Audio API — Flutter WebView compatible) ─────────────────
  // Why Web Audio API instead of new Audio()?
  // Android & iOS WebViews frequently block the HTML5 Audio element even after
  // a user gesture. AudioContext + fetch/decodeAudioData bypasses those blocks.
  const audioCtxRef = useRef(null);  // AudioContext instance
  const gainNodeRef = useRef(null);   // Master GainNode — mute/unmute by setting gain to 0/1
  const audioBufferRef = useRef(null);  // Decoded PCM buffer — spin loop
  const coinBufferRef = useRef(null);  // Decoded PCM buffer — coin one-shot
  const sourceNodeRef = useRef(null);  // Currently playing BufferSourceNode
  const isPlayingRef = useRef(false); // Guard against double-play
  const pendingPlayRef = useRef(false); // Spin started before ctx was unlocked?
  const ctxUnlockedRef = useRef(false); // AudioContext successfully resumed?
  const spinTimeoutRef = useRef(null);
  const spinFrameRef = useRef(null);
  const spinRotationRef = useRef(0);
  const spinPhaseRef = useRef("idle");
  const lastCountdownBeepRef = useRef(null);

  // ── Helper: start looping playback ──────────────────────────────────────────
  const startSpinAudio = () => {
    const ctx = audioCtxRef.current;
    const gain = gainNodeRef.current;
    const buffer = audioBufferRef.current;
    if (!ctx || !gain || !buffer || isPlayingRef.current) return;

    const src = ctx.createBufferSource();
    src.buffer = buffer;
    src.loop = true;
    src.connect(gain); // route through GainNode → speakers
    src.start(0);

    sourceNodeRef.current = src;
    isPlayingRef.current = true;
  };

  // ── Helper: stop spin playback ──────────────────────────────────────────────
  const stopSpinAudio = () => {
    if (sourceNodeRef.current) {
      try { sourceNodeRef.current.stop(); } catch (_) { }
      try { sourceNodeRef.current.disconnect(); } catch (_) { }
      sourceNodeRef.current = null;
    }
    isPlayingRef.current = false;
  };

  // ── Helper: play coin sound once (on successful bet) ────────────────────────
  const playCoinAudio = () => {
    const ctx = audioCtxRef.current;
    const gain = gainNodeRef.current;
    const buffer = coinBufferRef.current;
    if (!ctx || !gain || !buffer || !ctxUnlockedRef.current) return;

    const src = ctx.createBufferSource();
    src.buffer = buffer;
    src.loop = false; // one-shot — plays once and cleans up automatically
    src.connect(gain); // route through GainNode → speakers
    src.start(0);
    // No need to store the node — BufferSourceNode self-disposes after playback
  };

  // A short synthesized tick keeps the countdown synchronized without adding
  // another media file. Mobile browsers play it after the first user gesture.
  const playCountdownBeep = () => {
    const ctx = audioCtxRef.current;
    const gain = gainNodeRef.current;
    if (!ctx || !gain || !ctxUnlockedRef.current || isMuted) return;

    const oscillator = ctx.createOscillator();
    const tickGain = ctx.createGain();
    oscillator.type = "sine";
    oscillator.frequency.setValueAtTime(880, ctx.currentTime);
    tickGain.gain.setValueAtTime(0.12, ctx.currentTime);
    tickGain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.065);
    oscillator.connect(tickGain);
    tickGain.connect(gain);
    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + 0.07);
  };

  // ── Mount: create context, fetch+decode MP3, register unlock listener ────────
  useEffect(() => {
    // AudioContext is supported in all modern browsers and Flutter WebViews
    const AudioCtxClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtxClass) return; // Very old env — skip silently

    const ctx = new AudioCtxClass();
    audioCtxRef.current = ctx;

    // GainNode sits between all sources and the speakers.
    // gain.gain.value = 1 → full volume; 0 → muted (no CPU waste, instant).
    const gain = ctx.createGain();
    gain.gain.value = 1;
    gain.connect(ctx.destination);
    gainNodeRef.current = gain;

    // Fetch & decode both MP3s in parallel (done once, shared AudioContext)
    fetch(spinSoundSrc)
      .then((res) => res.arrayBuffer())
      .then((buf) => ctx.decodeAudioData(buf))
      .then((decoded) => { audioBufferRef.current = decoded; })
      .catch(() => { });

    fetch(coinSoundSrc)
      .then((res) => res.arrayBuffer())
      .then((buf) => ctx.decodeAudioData(buf))
      .then((decoded) => { coinBufferRef.current = decoded; })
      .catch(() => { });

    // ── Unlock AudioContext on first user gesture ────────────────────────────
    // AudioContext starts in 'suspended' state on mobile. We must call
    // ctx.resume() from inside a real user-interaction handler.
    const unlockCtx = () => {
      if (ctxUnlockedRef.current) return;

      const doResume = ctx.state === "suspended" ? ctx.resume() : Promise.resolve();
      doResume
        .then(() => {
          ctxUnlockedRef.current = true;
          // If the spin had already started while we were waiting → play now
          if (pendingPlayRef.current) {
            startSpinAudio();
          }
        })
        .catch(() => { });
    };

    // Cover all entry points: tap, click, touchend (touchstart can be too early
    // on some Android Chrome builds inside WebView)
    document.addEventListener("touchstart", unlockCtx, { passive: true, once: true });
    document.addEventListener("touchend", unlockCtx, { passive: true, once: true });
    document.addEventListener("click", unlockCtx, { once: true });

    return () => {
      document.removeEventListener("touchstart", unlockCtx);
      document.removeEventListener("touchend", unlockCtx);
      document.removeEventListener("click", unlockCtx);
      stopSpinAudio();
      ctx.close().catch(() => { });
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Mute / Unmute handler ───────────────────────────────────────────────────
  const toggleMute = () => {
    const gain = gainNodeRef.current;
    if (!gain) return;
    const next = !isMuted;
    gain.gain.value = next ? 0 : 1; // 0 = silent, 1 = full volume
    setIsMuted(next);
  };
  // ───────────────────────────────────────────────────────────────────────────

  // ── Play / stop in sync with the real wheel rotation ─────────────────────────
  useEffect(() => {
    if (isSpinning) {
      pendingPlayRef.current = true;
      if (ctxUnlockedRef.current) {
        startSpinAudio(); // Context already unlocked — play immediately
      }
      // Otherwise pendingPlayRef=true → unlockCtx() will start playback
    } else {
      pendingPlayRef.current = false;
      stopSpinAudio();
    }
  }, [isSpinning]); // eslint-disable-line react-hooks/exhaustive-deps
  // ─────────────────────────────────────────────────────────────────────────────

  const stopFreeSpin = () => {
    window.cancelAnimationFrame(spinFrameRef.current);
    spinFrameRef.current = null;
  };

  // Start a real, continuously moving wheel when betting closes. The wheel is
  // deliberately not told the winner yet, so it can never jump to a result.
  const startFreeSpin = () => {
    if (spinPhaseRef.current !== "idle") return;

    spinPhaseRef.current = "running";
    setSpinPhase("running");
    setIsSpinning(true);

    let previousTimestamp = null;
    const advance = (timestamp) => {
      if (spinPhaseRef.current !== "running") return;
      if (previousTimestamp !== null) {
        spinRotationRef.current += (timestamp - previousTimestamp) * FREE_SPIN_DEGREES_PER_MS;
        setWheelRotation(spinRotationRef.current);
      }
      previousTimestamp = timestamp;
      spinFrameRef.current = window.requestAnimationFrame(advance);
    };
    spinFrameRef.current = window.requestAnimationFrame(advance);
  };

  useEffect(() => {
    socket?.on("time", (clock) => {
      updateTime(clock);
      setTime(clock);
    });

    socket?.on("game", (game) => {
      currentGame = game?.UsersBits;
      if (game) {
        selectedFram = selectedFram = [
          { selectFrame: 1, Bit: 0 },
          { selectFrame: 2, Bit: 0 },
          { selectFrame: 3, Bit: 0 },
        ];
        updateGame(game);
        const totals = { 1: 0, 2: 0, 3: 0 };
        const mine = { 1: 0, 2: 0, 3: 0 };
        game.frameBitCoin?.forEach(({ selectFrame, bit }) => {
          if (totals[selectFrame] !== undefined) totals[selectFrame] = bit;
        });
        game.UsersBits?.forEach(({ userId: betUserId, SelectedFrame, Bit }) => {
          if (betUserId === userId && mine[SelectedFrame] !== undefined) {
            mine[SelectedFrame] += Bit;
          }
        });
        setPotBets({ totals, mine });
      }
    });

    socket?.on("randomWinnerNumber", (winner) => {
      const winnerNumber =
        typeof winner === "object"
          ? winner.number
          : winner;

      const segments = POT_SEGMENTS[winnerNumber];
      if (!segments) return;

      winnerFram = winnerNumber;
      // Keep the existing moving wheel position, then decelerate to either
      // matching fruit wedge beneath the top marker.
      const segmentIndex = segments[Math.floor(Math.random() * segments.length)];
      const targetRotation = (360 - segmentIndex * WEDGE_DEGREES) % 360;
      stopFreeSpin();
      spinPhaseRef.current = "settling";
      setSpinPhase("settling");
      setIsSpinning(true);
      const currentRotation = spinRotationRef.current;
      const currentRotationModulo = ((currentRotation % 360) + 360) % 360;
      const forwardDistance = (targetRotation - currentRotationModulo + 360) % 360;
      const finalRotation = currentRotation + (360 * 4) + forwardDistance;

      // First commit the final easing style, then set the end rotation on the
      // following animation frame. This guarantees a browser transition rather
      // than a one-frame jump.
      setWheelRotation(currentRotation);
      window.requestAnimationFrame(() => {
        setWheelRotation(finalRotation);
        spinRotationRef.current = finalRotation;
      });

      window.clearTimeout(spinTimeoutRef.current);
      spinTimeoutRef.current = window.setTimeout(() => {
        spinPhaseRef.current = "idle";
        setSpinPhase("idle");
        setIsSpinning(false);
      }, SPIN_DURATION_MS);
    });

    socket?.on("winnerUserArray", (winnerUser) => {
      winnerShow = winnerUser;
      // Open immediately when the game server publishes the result preview;
      // do not wait for accounting and Control Panel reporting to finish.
      gameRoundWinnerShow = gameRound;
      setWinnerModelOpen(true);
    });

    socket?.on("gameRound", (gameRoundNo) => {
      gameRound = gameRoundNo;
    });

    socket?.on("todayProfit", (profit) => {
      todayProfit = profit;
    });

    socket?.on("lastHistories", (histories) => {
      // The server prepends the newest winner, so preserve that order and show
      // the first nine entries.  Using slice(-9) displayed the oldest entries.
      historiesShow = Array.isArray(histories) ? histories : [];
      setResultHistory(historiesShow);
    });
    return () => {
      stopFreeSpin();
      window.clearTimeout(spinTimeoutRef.current);
      socket?.off("time");
      socket?.off("game");
      socket?.off("randomWinnerNumber");
      socket?.off("winnerUserArray");
      socket?.off("gameRound");
      socket?.off("todayProfit");
      socket?.off("lastHistories");
    };
  }, [socket]);

  socket?.on("historyRecord", (historyRecordData) => {
    historyRecord = historyRecordData;
  });
  const intervalId = () => {
    const randomNumber = Math.floor(Math.random() * (900 - 700) + 700);
    const firstIntervalId = setInterval(() => {
      if (seconds < 10) {
        setRoundCounter((prevRoundCounter) => (prevRoundCounter % 7) + 1);
      }
      if (seconds >= 10) {
        clearInterval(firstIntervalId);
      }
    }, randomNumber);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds + 1);
      setElapsedTime((prevElapsedTime) => prevElapsedTime + 1000);

      if (seconds === 15) {
        setSeconds(0);
        setRoundCounter(-1);
        setElapsedTime(0);
        intervalId();
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const handleOpenModel = (type) => {
    if (type === "records") {
      setRecordsDialogOpen(true);
      setRulesDialogOpen(false);
      setLeaderboardDialogOpen(false);
      socket?.off("historyRecord")?.emit("historyRecord", {
        _id: userData?._id,
      });
    } else if (type === "leaderboard") {
      setLeaderboardDialogOpen(true);
      setRecordsDialogOpen(false);
      setRulesDialogOpen(false);
    } else {
      setRulesDialogOpen(true);
      setRecordsDialogOpen(false);
      setLeaderboardDialogOpen(false);
    }
  };

  const updateTime = (clock) => {
    const phase = clock?.phase;
    const remaining = Number(clock?.remaining);
    if (!phase || Number.isNaN(remaining)) return;

    if (phase === "betting") {
      if (remaining === 20) {
        selectedCoin = gameCoin[0];
        setWinnerModelOpen(false);
        setBetChips({ 1: [], 2: [], 3: [] });
        chipSequenceRef.current = 0;
      }
      setCanPressCoins(remaining > 3);
      setTimerText(String(remaining));
      if (remaining > 0 && remaining <= 20 && lastCountdownBeepRef.current !== remaining) {
        lastCountdownBeepRef.current = remaining;
        playCountdownBeep();
      }
      if (remaining === 0) startFreeSpin();
      return;
    }

    if (phase === "spin") {
      lastCountdownBeepRef.current = null;
      setCanPressCoins(false);
      setTimerText(""); // No countdown is shown while the wheel is moving.
      return;
    }

    if (phase === "result") {
      setCanPressCoins(false);
      setTimerText("");
      gameRoundWinnerShow = gameRound;
      setWinnerModelOpen(true);
      if (remaining === 0) {
        socket?.emit("user", { _id: userData?._id });
      }
    }
  };

  const updateGame = (game) => {
    const findUser = game?.UsersBits?.filter((user) => {
      return user?.userId === userId;
    });
    findUser?.forEach((data) => {
      const { Bit, SelectedFrame } = data;
      const gameIndex = selectedFram?.findIndex((frame) => frame?.selectFrame === SelectedFrame);
      if (gameIndex !== -1) {
        selectedFram[gameIndex].Bit += Bit;
      }
    });
  };

  const getAmount = (coin) => {
    let amount = 0;
    if (coin == gameCoin[0]) amount = gameCoin[0];
    else if (coin == gameCoin[1]) amount = gameCoin[1];
    else if (coin == gameCoin[2]) amount = gameCoin[2];
    else if (coin == gameCoin[3]) amount = gameCoin[3];
    else if (coin == gameCoin[4]) amount = gameCoin[4];

    return amount;
  };

  const addBit = (bitcoin, myframe) => {
    let amount = getAmount(bitcoin);
    if (bitcoin != -1 && myframe !== 0) {
      if (userData?.coin - amount >= 0) {
        userData.coin -= amount;
        socket?.emit("bit", {
          User: userData,
          Bit: bitcoin,
          SelectedFrame: myframe,
        });

        playCoinAudio(); // 🪙 play coin sound on every successful bet

        const selectedFrameIndex = selectedFram?.findIndex((frame) => frame.selectFrame === myframe);
        selectedFram[selectedFrameIndex].Bit += bitcoin;
        setPotBets((current) => ({
          totals: {
            ...current.totals,
            [myframe]: (current.totals[myframe] || 0) + bitcoin,
          },
          mine: {
            ...current.mine,
            [myframe]: (current.mine[myframe] || 0) + bitcoin,
          },
        }));
        const sequence = chipSequenceRef.current++;
        const placedChip = {
          id: `${Date.now()}-${sequence}`,
          amount: bitcoin,
          left: 16 + ((sequence * 23) % 68),
          top: 16 + ((sequence * 31) % 62),
        };
        setBetChips((current) => ({
          ...current,
          [myframe]: [...(current[myframe] || []), placedChip].slice(-14),
        }));
      } else {
        ToastConent("You don't have enough coins. Please recharge first!", "warning");
      }
    } else {
      ToastConent("Missing to select any Coin", "info");
    }
  };

  const handleFramClick = (fram) => {
    if (selectedCoin >= 0) {
      addBit(selectedCoin == 0 ? gameCoin[0] : selectedCoin, fram);
    }
  };

  return (
    <div className="row">
      <div className="col-12 col-md-3"></div>
      <div className="col-12 col-md-6">
        <div className="show-game">
          <div className="wheelContent">
            <div className="top-bar">
              <div className="roundNumber">
                <h6>
                  Round: <span>{gameRound}</span>
                </h6>
              </div>
              <div className="top-button">
                <button
                  className="records-btn"
                  onClick={(event) => {
                    handleOpenModel("records");
                    event.stopPropagation();
                  }}
                ></button>
                <button
                  className="rules-btn"
                  onClick={(event) => {
                    handleOpenModel("rules");
                    event.stopPropagation();
                  }}
                ></button>
                <button
                  className="leaderboard-btn"
                  onClick={(event) => {
                    handleOpenModel("leaderboard");
                    event.stopPropagation();
                  }}
                ></button>

                {/* Mute / Unmute toggle */}
                <button
                  className="mute-btn"
                  onClick={(event) => {
                    toggleMute();
                    event.stopPropagation();
                  }}
                  style={{
                    backgroundImage: `url(${isMuted ? MuteIcon : UnmuteIcon})`,
                  }}
                ></button>
              </div>
            </div>


            <div className="wheel-image-wrapper">
              {/* Decorative sign and columns sit behind the wheel. */}
              <img
                src={WheelStandTop}
                className="wheel-stand-top"
                alt="FruitLoop"
              />

              {/* Only the upper half of the wheel is exposed. */}
              <div className="wheel-half-window">
                <div className="wheel-circle-clip">
                <img
                  src={WheelCircle}
                  className="wheel-image"
                  style={{
                    transform: `rotate(${wheelRotation}deg)`,
                    transition: spinPhase === "settling"
                      ? `transform ${SPIN_DURATION_MS}ms cubic-bezier(0.08, 0.82, 0.16, 1)`
                      : "none",
                    }}
                  />
                </div>
              </div>

              {/* The base masks the lower wheel, making it appear built in. */}
              <img
                src={WheelBottomStand}
                className="wheel-bottom-stand"
                alt=""
                aria-hidden="true"
              />

              {/* The center medallion and timer remain above the base. */}
              <div className="wheel-center-hub">
                <img src={WheelMiddle} className="wheel-middle-img" alt="" />
                <div className="wheel-center-text">
                  <strong className="wheel-timer">{timerText}</strong>
                </div>
              </div>

              {/* Fixed, compact result pointer at 12 o'clock. */}
              <img
                src={WheelPointer}
                className="wheel-pointer"
                alt=""
                aria-hidden="true"
              />
            </div>

            {/* Result — below the Wheel */}
            <div className="fruitloop-master-box">
              <div className="result-content">
                <img src={ResultBanner} className="result-banner-bg" alt="" />
                <div className="result-box">
                  <h5>Result</h5>
                  <div className="border-line"></div>
                  <div className="last-reslut">
                    {resultHistory.length > 0 ? (
                      resultHistory.slice(0, 9).map((item, index) => {
                        return (
                          <div className="gift-reslut" key={index}>
                            <div className="new-label">
                              <span>NEW</span>
                            </div>
                            <img src={imageShowData[item - 1]} alt="result item" />
                          </div>
                        );
                      })
                    ) : (
                      <h6
                        style={{
                          color: "white",
                          textAlign: "center",
                          width: "100%",
                          marginTop: "5px",
                        }}
                      >
                        Not Result...
                      </h6>
                    )}
                  </div>
                </div>
              </div>

              {/* FruitLoop Betting Area */}
              <div className="fruitloop-betting">

                <div 
                  className="fruit-bet-item"
                  onClick={() => handleFramClick(1)}
                >
                  <div className="fruit-bet-visual">
                    <img src={AppleBox} alt="Apple" />
                    <div className="fruit-bet-chips">
                      {betChips[1].map((chip) => (
                        <span className="fruit-placed-chip" key={chip.id} style={{ left: `${chip.left}%`, top: `${chip.top}%` }}>
                          <img src={chipImageForAmount(chip.amount)} alt="" />
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="bet-info">
                    <div>Pot: {potBets.totals[1].toLocaleString()}</div>
                    <div>You: {potBets.mine[1].toLocaleString()}</div>
                  </div>
                </div>

                <div 
                  className="fruit-bet-item"
                  onClick={() => handleFramClick(2)}
                >
                  <div className="fruit-bet-visual">
                    <img src={MangoBox} alt="Mango" />
                    <div className="fruit-bet-chips">
                      {betChips[2].map((chip) => (
                        <span className="fruit-placed-chip" key={chip.id} style={{ left: `${chip.left}%`, top: `${chip.top}%` }}>
                          <img src={chipImageForAmount(chip.amount)} alt="" />
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="bet-info">
                    <div>Pot: {potBets.totals[2].toLocaleString()}</div>
                    <div>You: {potBets.mine[2].toLocaleString()}</div>
                  </div>
                </div>

                <div
                  className="fruit-bet-item"
                  onClick={() => handleFramClick(3)}
                >
                  <div className="fruit-bet-visual">
                    <img src={WatermelonBox} alt="Watermelon" />
                    <div className="fruit-bet-chips">
                      {betChips[3].map((chip) => (
                        <span className="fruit-placed-chip" key={chip.id} style={{ left: `${chip.left}%`, top: `${chip.top}%` }}>
                          <img src={chipImageForAmount(chip.amount)} alt="" />
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="bet-info">
                    <div className="fruit-pot">Pot: {potBets.totals[3].toLocaleString()}</div>
                    <div className="fruit-you">You: {potBets.mine[3].toLocaleString()}</div>
                  </div>
                </div>
              </div>

              {/* Balance & Profit — below the Result */}
              <div className="balance-profile">
                <div className="balance-box">
                  <img src={BalanceBanner} className="balance-banner-bg" alt="" />
                  <div className="balance-content">
                    <h6>Diamond</h6>
                    <div className="balance-number">
                      <img src={DimondIcon} />
                      <h5>{userData?.coin ? userData?.coin?.toLocaleString() : 0}</h5>
                    </div>
                  </div>
                </div>

                {/* Coin selector — At the Bottom */}
                <div className="dimond-select">
                  {gameCoin?.map((coin, index) => (
                    <CoinButton
                      key={index}
                      number={coin}
                      funcClick={() => {
                        selectedCoin = coin;
                      }}
                      selectedClass={selectedCoin == coin ? "selectedCoin" : ""}
                      disabledClass={canPressCoins === false ? "coinDisabled" : ""}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div>
            <RecordsDialog open={recordsDialogOpen} historyRecord={historyRecord} setOpen={setRecordsDialogOpen} />
          </div>
          <RulesDialog open={rulesDialogOpen} setOpen={setRulesDialogOpen} />
          <Leaderboard dialog={leaderboardDialogOpen} setDialog={setLeaderboardDialogOpen} />
          <WinnerDialog open={winnerModelOpen} setOpen={setWinnerModelOpen} winnerShow={winnerShow} currentGame={currentGame} userData={userData} gameRound={gameRoundWinnerShow} />
        </div>
      </div>
    </div>
  );
}
